import { render, staticRenderFns } from "./TextureEffectDialog.vue?vue&type=template&id=0a4e5494&scoped=true"
import script from "./TextureEffectDialog.vue?vue&type=script&lang=js"
export * from "./TextureEffectDialog.vue?vue&type=script&lang=js"
import style0 from "./TextureEffectDialog.vue?vue&type=style&index=0&id=0a4e5494&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e5494",
  null
  
)

export default component.exports